import React, { useEffect, useState } from 'react';
import { Panel } from 'primereact/panel';

import fetchApi from '../lib/fetchApi.js';

const Dashboard = ({ setPageParams }) => {
  const [me, setMe] = useState(null);
  const [weather, setWeather] = useState(null);

  useEffect(() => {
    setPageParams({ alias: 'dashboard', title: '儀表板' });
  }, []);

  useEffect(() => {
    (async () => {
      const response = await fetchApi('/api/v1/user/getMe');
      if (response?.data?.user) setMe(response.data.user);
      try {
        const w = await fetch('https://data.weather.gov.hk/weatherAPI/opendata/weather.php?dataType=flw&lang=tc');
        if (w.ok) setWeather(await w.json());
      } catch (e) {
        /* weather is non-critical */
      }
    })();
  }, []);

  const greeting = me?.nickname ? `${me.nickname}，` : '';

  return (
    <>
      <div className="likkan-greeting">{greeting}你好👋 歡迎使用力勤物流搬運系統！</div>
      <div className="likkan-panel-grid">
        <Panel header="🔔 公告">
          <div className="mb-2">近日天氣炎熱，勞工處多次發出工作暑熱警告，請各員工多加休息，注意健康。</div>
          <div className="mb-2">電子報價工具已經啟用！</div>
        </Panel>
        {weather && (
          <Panel header="🌈 天氣概況">
            <p className="m-0">{weather.generalSituation}</p>
          </Panel>
        )}
      </div>
    </>
  );
};

export default Dashboard;
